import styled from 'styled-components';

import { ISelectionOptions } from './types';

const SelectionOptions = styled.fieldset<ISelectionOptions>`
  border: none;
  margin: 0 auto 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0;
  min-width: 100%;
  max-width: 100%;
`;

export default SelectionOptions;
